import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { createStatusTranslator, createTypeTranslator } from '../utils/statusTranslation';
import {
  getAllDocuments,
  downloadDocument,
  updateDocument,
} from "../redux/actions/documentActions";

import { fetchTasks } from "../redux/actions/taskActions";
import { fetchFiles } from "../redux/actions/fileActions";
import { fetchRelationships } from "../redux/actions/relationshipActions";
import { getAppointmentsByCaseId } from "../redux/actions/appointmentActions";

import { useNavigate, useParams } from "react-router-dom";

import Avatar from "@mui/material/Avatar";
import {
  Snackbar,
  SnackbarContent,
  TableSortLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Button,
  Container,
  TextField,
  Grid,
  // Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Breadcrumbs,
  Typography,
  Link,
  // Autocomplete,
  // Avatar,
  Stack,
  // InputAdornment,
  CircularProgress,
  TableContainer,
  Tabs,
  Tab,
  FormControl,
  Badge,
} from "@mui/material";
import {
  InputAdornment,
  Box,
  Autocomplete,
  // TableSortLabel,
} from "@mui/material";
import { windowsTableStyles } from "../styles/windowsTableStyles";

import BreadcrumbNav from "../components/BreadcrumbNav";
import { smallTitle } from "../styles/typography";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline"; // User icon
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined"; // Office icon
import { useLocation } from "react-router-dom";

import NoteIcon from "@mui/icons-material/Note";
import NoteOutlinedIcon from "@mui/icons-material/NoteOutlined";
// import AzureAuthenticator from "../components/TestComp";
import AzureAuthenticator from "../components/TestComp";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";

import axios from "../utils/axiosConfig";
import NotesDialog from "../components/NotesDialog";

import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SendIcon from "@mui/icons-material/Send";
import EditIcon from "@mui/icons-material/Edit";

import DescriptionIcon from "@mui/icons-material/Description"; // Default icon
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"; // PDF icon
import TextSnippetIcon from "@mui/icons-material/TextSnippet"; // Text file icon
import MicrosoftWordIcon from "../styles/MicrosoftWordIcon";

import { DOCUMENT_UPDATE_RESET } from "../redux/constants/documentConstants"; // Import the reset action type
import { actionButtonStyles } from "../styles/actionButton";
import AddIcon from "@mui/icons-material/Add";

import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import GavelIcon from "@mui/icons-material/Gavel"; // Courtroom icon

import { listTimesheets } from "../redux/actions/timesheetActions";

import CustomAutocomplete from "../components/CustomAutocomplete";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import { textFieldStyles } from "../styles/textFieldStyles";
import FileAutocomplete from "../components/FileAutocomplete";

const breadcrumbs = [{ label: "Home", href: "/" }];

const tableStyles = windowsTableStyles();

const mimeToExtension = {
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "docx",
  "application/pdf": "pdf",
  "image/jpeg": "jpg",
  "image/png": "png",
  // Add other MIME types and their corresponding extensions as needed
};

const SearchResultsPage = () => {
  const { t } = useTranslation(['pages', 'common', 'buttons']);
  const location = useLocation();
  const {
    filteredFiles,
    filteredRelationships,
    filteredTasks,
    filteredAppointments,
    filteredTimesheets,
    searchTerm,
  } = location.state || {};
  const navigate = useNavigate();

  const dispatch = useDispatch();

  // Create translators using shared utilities
  const translateStatus = createStatusTranslator(t);
  const translateType = createTypeTranslator(t);

  const fileInputRef = useRef(null);
  const { files } = useSelector((state) => state.fileList);
  const { relationships } = useSelector((state) => state.relationshipList);
  const { user } = useSelector((state) => state.userLoaded); // Assuming user info is stored in auth state

  const { timesheets } = useSelector((state) => state.timesheetList);

  // const { appointments = [], } = useSelector((state) => state.appointmentsByCase);

  const fileUrl = useSelector((state) => state.documentDownload.fileUrl);
  const { documents, loading, error } = useSelector(
    (state) => state.documentList
  );
  const { success: updateSuccess } = useSelector(
    (state) => state.documentUpdate
  );

  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [tabValue, setTabValue] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [newNoteDate, setNewNoteDate] = useState("");
  const [showNewNoteField, setShowNewNoteField] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Add severity state

  const [search, setSearch] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterFolder, setFilterFolder] = useState("");
  const [filterOwner, setFilterOwner] = useState("");
  const [filterCaseFile, setFilterCaseFile] = useState(null);

  // const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [caseFilter, setCaseFilter] = useState(null);
  const [ownerFilter, setOwnerFilter] = useState(null);

  const [delayedCheck, setDelayedCheck] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const [billingPeriod, setBillingPeriod] = useState([null, null]);

  // const { id } = useParams();

  useEffect(() => {
    dispatch(getAllDocuments());
  }, [dispatch]);

  useEffect(() => {
    if (updateSuccess) {
      setNotification({
        open: true,
        message: t('pages:documents.document_updated'),
        severity: "success",
      });
      dispatch({ type: DOCUMENT_UPDATE_RESET }); // Reset the update success state
    }
  }, [updateSuccess, dispatch]);

  const handleDownload = async (documentId) => {
    const { data } = await axios.get(`/api/documents/download/${documentId}`);
    if (data) {
      window.open(data.fileUrl, "_blank");
    }
  };

  const handleView = async (documentId) => {
    const { data } = await axios.get(`/api/documents/download/${documentId}`);
    if (data) {
      const viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(
        data.fileUrl
      )}&embedded=true`;
      window.open(viewerUrl, "_blank");
    }
  };

  const handleSendEmail = async (documentId) => {
    const { data } = await axios.get(`/api/documents/download/${documentId}`);

    if (data) {
      const fileUrl = data.fileUrl;
      const fileResponse = await axios.get(fileUrl, { responseType: "blob" });

      const getFileExtension = (mimeType) => {
        return mimeToExtension[mimeType] || "bin"; // Default to 'bin' if MIME type is not found
      };

      const fileExtension = getFileExtension(fileResponse.data.type);
      const fileName = `${documentId}.${fileExtension}`;

      const file = new File([fileResponse.data], fileName, {
        type: fileResponse.data.type,
      });

      const base64Content = await convertFileToBase64(file);

      navigate("/send-email", {
        // state: { attachments: [{ file, base64Content}] },
        state: { attachments: [{ file, base64Content, name: file.name }] },
      });
    }
  };

  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleUpdateDocument = (documentId) => {
    fileInputRef.current.click();
    fileInputRef.current.onchange = async (event) => {
      const file = event.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        dispatch(updateDocument(documentId, formData));
      }
    };
  };

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleFilterTypeChange = (event, newValue) => {
    setFilterType(newValue ? newValue.label : "");
  };

  const handleFilterFolderChange = (event, newValue) => {
    setFilterFolder(newValue || "");
  };

  const handleFilterOwnerChange = (event, newValue) => {
    setFilterOwner(newValue || "");
  };

  const handleFilterCaseFileChange = (event, newValue) => {
    setFilterCaseFile(newValue || null);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const userFiles = files?.filter((file) => {
    if (user?.role === "Manager") {
      return true; // Managers can see all files
    } else if (user?.role === "Responsible Lawyer") {
      return file.officeMembers.some(
        (member) =>
          member.member._id === user.relationship &&
          member.role === "Responsible Lawyer"
      );
    } else if (user?.role === "Assistant Lawyer") {
      return file.officeMembers.some(
        (member) =>
          member.member._id === user.relationship &&
          member.role === "Treating Lawyer"
      );
    }
    return false;
  });
  useEffect(() => {
    console.log("userfiles", userFiles);
  }, [userFiles]);

  const filteredDocuments = documents
    .filter((document) => {
      const normalizeString = (str) => str?.replace(/\s+/g, "").toLowerCase();

      const searchText = normalizeString(search);

      return (
        userFiles.some((file) => file._id === document.caseFile._id) &&
        (normalizeString(document.title).includes(searchText) ||
          normalizeString(document.type).includes(searchText) ||
          normalizeString(document.folder).includes(searchText) ||
          normalizeString(document.caseFile.name).includes(searchText) ||
          normalizeString(
            `${document.owner.firstName || ""} ${
              document.owner.middleName || ""
            } ${document.owner.lastName || ""}`
          ).includes(searchText)) &&
        (filterType ? document.type === filterType : true) &&
        (filterFolder ? document.folder === filterFolder : true) &&
        (filterOwner
          ? `${document.owner.firstName} ${document.owner.lastName}` ===
            filterOwner
          : true) &&
        (filterCaseFile ? document.caseFile._id === filterCaseFile._id : true)
      );
    })
    .sort((a, b) => {
      if (orderBy === "title") {
        return order === "asc"
          ? a.title.localeCompare(b.title)
          : b.title.localeCompare(a.title);
      } else if (orderBy === "modifiedDate") {
        return order === "asc"
          ? new Date(a.modifiedDate) - new Date(b.modifiedDate)
          : new Date(b.modifiedDate) - new Date(a.modifiedDate);
      } else if (orderBy === "owner") {
        return order === "asc"
          ? `${a.owner.firstName} ${a.owner.lastName}`.localeCompare(
              `${b.owner.firstName} ${b.owner.lastName}`
            )
          : `${b.owner.firstName} ${b.owner.lastName}`.localeCompare(
              `${a.owner.firstName} ${a.owner.lastName}`
            );
      } else if (orderBy === "caseFile") {
        return order === "asc"
          ? a.caseFile.name.localeCompare(b.caseFile.name)
          : b.caseFile.name.localeCompare(a.caseFile.name);
      } else if (orderBy === "type") {
        return order === "asc"
          ? a.type.localeCompare(b.type)
          : b.type.localeCompare(a.type);
      } else if (orderBy === "folder") {
        return order === "asc"
          ? a.folder.localeCompare(b.folder)
          : b.folder.localeCompare(a.folder);
      }
      return 0;
    });

  const paginatedDocuments = filteredDocuments.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const owners = [
    ...new Set(
      documents.map((doc) => `${doc.owner.firstName} ${doc.owner.lastName}`)
    ),
  ];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //   const handleCreateRelationship = () => {
  //     navigate("/relationships/create");
  //   };

  const sortedRelationships = filteredRelationships?.sort((a, b) => {
    if (orderBy) {
      let aValue = a[orderBy];
      let bValue = b[orderBy];

      if (orderBy === "name") {
        aValue =
          a.contractType === "Individual"
            ? `${a.firstName || ""} ${a.middleName || ""} ${
                a.lastName || ""
              }`.trim()
            : a.businessName || "";
        bValue =
          b.contractType === "Individual"
            ? `${b.firstName || ""} ${b.middleName || ""} ${
                b.lastName || ""
              }`.trim()
            : b.businessName || "";
      } else if (orderBy === "phone" || orderBy === "email") {
        aValue =
          a.contacts && a.contacts.length > 0 ? a.contacts[0][orderBy] : "";
        bValue =
          b.contacts && b.contacts.length > 0 ? b.contacts[0][orderBy] : "";
      }

      if (order === "asc") {
        return aValue < bValue ? -1 : 1;
      } else {
        return aValue > bValue ? -1 : 1;
      }
    }
    return 0;
  });

  const sortedFiles = filteredFiles.sort((a, b) => {
    if (orderBy) {
      let aValue = a[orderBy];
      let bValue = b[orderBy];

      if (orderBy === "responsibleLawyer") {
        aValue =
          a.officeMembers.find((member) => member.role === "Responsible Lawyer")
            ?.member?.firstName || "";
        bValue =
          b.officeMembers.find((member) => member.role === "Responsible Lawyer")
            ?.member?.firstName || "";
      } else if (orderBy === "treatingLawyer") {
        aValue =
          a.officeMembers.find((member) => member.role === "Treating Lawyer")
            ?.member?.firstName || "";
        bValue =
          b.officeMembers.find((member) => member.role === "Treating Lawyer")
            ?.member?.firstName || "";
      } else if (orderBy === "clientName") {
        aValue =
          a.parties.find((party) => party.type === "Client")?.name?.firstName ||
          "";
        bValue =
          b.parties.find((party) => party.type === "Client")?.name?.firstName ||
          "";
      }

      if (order === "asc") {
        return aValue < bValue ? -1 : 1;
      } else {
        return aValue > bValue ? -1 : 1;
      }
    }
    return 0;
  });

  const handleOpenNotes = async (file) => {
    try {
      const response = await axios.get(`/api/files/${file._id}`);
      setSelectedFile(response.data);
      setNotes(response.data.notes);
    } catch (error) {
      console.error("Error fetching notes:", error);
    }
  };

  const handleCloseNotes = () => {
    setSelectedFile(null);
    setNotes([]);
    setNewNote("");
    setNewNoteDate("");
    setShowNewNoteField(false);
  };

  const handleAddNote = () => {
    setNewNoteDate(new Date().toLocaleDateString());
    setShowNewNoteField(true);
  };
  const handleSaveAllNotes = async () => {
    try {
      const updatePromises = notes.map((note) =>
        axios.put(
          `/api/files/${selectedFile._id}/notes/${note._id}`,
          {
            content: note.content,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
      );

      if (newNote) {
        updatePromises.push(
          axios.post(
            `/api/files/${selectedFile._id}/notes`,
            {
              content: newNote,
              date: new Date(),
            },
            {
              headers: { "Content-Type": "application/json" },
            }
          )
        );
      }
      await Promise.all(updatePromises);
      const response = await axios.get(`/api/files/${selectedFile._id}`);
      const updatedFile = response.data;
      setNotes(updatedFile.notes);
      setNewNote("");
      setNewNoteDate("");
      setShowNewNoteField(false);
      setSnackbarMessage("Notes saved successfully");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error saving notes:", error);
    }
  };

  const handleDeleteNote = async (noteId) => {
    try {
      const response = await axios.delete(
        `/api/files/${selectedFile._id}/notes/${noteId}`
      );
      const updatedFile = response.data;
      setNotes(updatedFile.notes);
    } catch (error) {
      console.error("Error deleting note:", error);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDelayedCheck(true);
    }, 1000); // Delay in milliseconds

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);
  useEffect(() => {
    dispatch(fetchTasks());
    dispatch(fetchFiles());
    dispatch(fetchRelationships());
  }, [dispatch]);

  const handleCreateTask = () => {
    navigate("/task/create");
  };

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };

  const normalizeString = (str) => str?.replace(/\s+/g, "").toLowerCase();

  const filteredTask = filteredTasks?.filter(
    (task) =>
      userFiles.some((file) => file._id === task.case?._id) &&
      (searchTerm
        ? normalizeString(
            `${task.owner?.firstName || ""} ${task.owner?.middleName || ""} ${
              task.owner?.lastName || ""
            }`
          ).includes(normalizeString(searchTerm)) ||
          normalizeString(task.type).includes(normalizeString(searchTerm)) ||
          normalizeString(task.case?.name).includes(
            normalizeString(searchTerm)
          ) ||
          normalizeString(task.subject).includes(normalizeString(searchTerm)) ||
          normalizeString(task.case?.fileNo).includes(
            normalizeString(searchTerm)
          ) ||
          normalizeString(task.description).includes(
            normalizeString(searchTerm)
          )
        : true) &&
      (statusFilter
        ? normalizeString(task.status) === normalizeString(statusFilter)
        : true) &&
      (caseFilter ? task.case._id === caseFilter._id : true) &&
      (ownerFilter ? task.owner._id === ownerFilter._id : true)
  );

  const sortedTasks = filteredTask?.sort((a, b) => {
    if (orderBy) {
      let aValue = a[orderBy];
      let bValue = b[orderBy];

      if (orderBy === "owner") {
        aValue = a.owner
          ? `${a.owner.firstName} ${a.owner.middleName || ""} ${
              a.owner.lastName
            }`.trim()
          : "";
        bValue = b.owner
          ? `${b.owner.firstName} ${b.owner.middleName || ""} ${
              b.owner.lastName
            }`.trim()
          : "";
      } else if (orderBy === "case") {
        aValue = a.case ? a.case.name : "";
        bValue = b.case ? b.case.name : "";
      }

      if (order === "asc") {
        return aValue < bValue ? -1 : 1;
      } else {
        return aValue > bValue ? -1 : 1;
      }
    }
    return 0;
  });

  const stringToColor = (string) => {
    if (!string) return "#ccc"; // Default gray color if string is empty

    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += ("00" + value.toString(16)).slice(-2);
    }

    return color;
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "High":
      case t('pages:tasks.priority_options.high'):
        return "red"; // Red for high priority
      case "Medium":
      case t('pages:tasks.priority_options.medium'):
        return "orange"; // Orange for medium priority
      case "Low":
      case t('pages:tasks.priority_options.low'):
        return "green"; // Green for low priority
      default:
        return "gray"; // Default color if no priority is set
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "In progress":
        return "blue"; // Blue for In Progress
      case "Not started":
        return "gray"; // Gray for Not Started
      case "Completed":
        return "#85bc20"; // Green for Completed
      default:
        return "transparent"; // Transparent if no status
    }
  };
  const getColor = (color) => {
    switch (color) {
      case "Red":
        return "#e5202e"; // Blue for In Progress
      case "Blue":
        return "Blue"; // Gray for Not Started
      case "Green":
        return "#85bc20"; // Green for Completed
      case "Yellow":
        return "Yellow";
      default:
        return "transparent"; // Transparent if no status
    }
  };

  //   useEffect(() => {
  //     dispatch(getAppointmentsByCaseId(id)); // Fetch appointments based on the case ID
  //     // dispatch(getHearingsByCaseId(id)); // Fetch hearings based on the case ID
  //   }, [dispatch, id]);

  //   useEffect(() => {
  //     console.log("appointments", appointments);
  //   }, [appointments]);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  //   const handleCreateAppointment = () => {
  //     navigate('/appointment/create', { state: { caseId: id } });
  //     handleMenuClose();
  //   };

  //   const handleCreateHearing = () => {
  //     navigate('/hearing/create', { state: { caseId: id } });
  //     handleMenuClose();
  //   };

  //   const filteredAppointment = filteredAppointments?.filter((appointment) =>
  //     userFiles.some((file) => file._id === appointment.case?._id)
  //   );

  //   console.log("filterred appointment chekcing", filteredAppointment)

  const combinedEvents = [...filteredAppointments];

  //   const getColor = (color) => {
  //     switch (color) {
  //       case "Red":
  //         return "#e5202e";  // Blue for In Progress
  //       case "Blue":
  //         return "Blue";  // Gray for Not Started
  //       case "Green":
  //         return "#85bc20";  // Green for Completed
  //       case "Yellow":
  //         return "Yellow";
  //       default:
  //         return "transparent";  // Transparent if no status
  //     }
  //   };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDelayedCheck(true);
    }, 1000); // Delay in milliseconds

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);

  // const handleInputClick = () => {
  //   setTriggerEffect((prev) => !prev); // Toggle the state to trigger `useEffect`
  // };
  useEffect(() => {
    dispatch(listTimesheets());
    dispatch(fetchFiles());
    dispatch(fetchRelationships());
  }, [dispatch]);

  useEffect(() => {
    if (timesheets) {
      console.log("timesheet", timesheets);
    }
  }, [timesheets, files, relationships]);

  // useEffect(() => {
  //   console.log("billingPeriod", sidebarOpen);
  // }, [billingPeriod]);

  //   useEffect(() => {
  //     console.log("sidebarOpen", sidebarOpen);
  //   }, [sidebarOpen]);

  useEffect(() => {
    if (isPickerOpen) {
      const updatePopperPosition = () => {
        const popper = document.querySelector(
          ".MuiPopper-root.MuiPickersPopper-root"
        );
        console.log("location", location.pathname.includes("/timesheets"));
        if (popper && location.pathname.includes("/timesheets")) {
          popper.style.transition = "transform 0.3s ease, left 0.3s ease"; // Smooth transition
          //   if (sidebarOpen) {
          //     popper.style.transform = "translate(-51.8%, 51.8%)";
          //     popper.style.left = "59%";
          //   } else {
          //     popper.style.transform = "translate(-51.8%, 51.8%)";
          //     popper.style.left = "54%";
          //   }
          // popper.style.transform = "translate(-51.8%, 51.8%)";
          // popper.style.left = "54%";
        }
      };

      // Trigger the update with a minimal delay
      const timeout = setTimeout(updatePopperPosition, 0);

      return () => clearTimeout(timeout); // Cleanup timeout when effect re-runs
    }
  }, [isPickerOpen, billingPeriod]);

  const convertToDecimalHours = (time) => {
    const [hours, minutes, seconds] = time.split(":").map(Number);
    return (hours + minutes / 60 + seconds / 3600).toFixed(2);
  };

  const handleFocus = () => {
    console.log("The element is focused");

    // Correct class selector with the '.' prefix
    const element = document.querySelector(
      ".css-148xbgl-MuiInputBase-root-MuiOutlinedInput-root"
    );

    if (element) {
      console.log("The element is found");

      // Check if parent element exists
      if (element.parentElement) {
        console.log("The element has a parent");
        element.parentElement.style.boxShadow = "none";
      } else {
        console.log("The element has no parent");
      }

      // Apply styles to the element
      element.style.backgroundColor = "#f0f0f0";
      element.style.boxShadow =
        "inset 4px 4px 8px #d1d9e6, inset -4px -4px 8px #ffffff";
      document.addEventListener("click", handleClickOutside);
    } else {
      console.log("The element was not found");
    }
  };

  const handleBlur = () => {
    console.log("The element has mouse out");
    const element = document.querySelector(
      ".css-148xbgl-MuiInputBase-root-MuiOutlinedInput-root"
    );

    if (element && document.activeElement === element) {
      if (element.parentElement) {
        console.log("The element is not focused");
        // element.style.backgroundColor = "";
        element.style.boxShadow =
          "2px 2px 4px rgba(0,0,0,0.1), -2px -2px 4px rgba(255,255,255,0.7)";
      }
      element.style.backgroundColor = "";
      element.style.boxShadow = "none";
      document.removeEventListener("click", handleClickOutside);
    }
  };

  const handleClickOutside = (event) => {
    console.log("Clicked outside the input field");
    // if (inputRef.current && !inputRef.current.contains(event.target)) {
    //   console.log('Clicked outside the input field');
    handleBlur();
    // }
  };

  const filteredTimesheet = filteredTimesheets.filter((timesheet) => {
    const normalizeString = (str) => str?.replace(/\s+/g, "").toLowerCase();

    const matchesSearchTerm = searchTerm
      ? normalizeString(timesheet.description).includes(
          normalizeString(searchTerm)
        ) ||
        (timesheet.owner &&
          normalizeString(
            `${timesheet.owner?.firstName || ""} ${
              timesheet.owner?.middleName || ""
            } ${timesheet.owner?.lastName || ""}`
          ).includes(normalizeString(searchTerm))) ||
        (timesheet.fileCase &&
          normalizeString(timesheet.fileCase?.name).includes(
            normalizeString(searchTerm)
          )) ||
        normalizeString(timesheet.fileCase?.fileNo).includes(
          normalizeString(searchTerm)
        ) ||
        normalizeString(timesheet.type).includes(normalizeString(searchTerm))
      : true;

    const matchesCaseFilter = caseFilter
      ? timesheet.fileCase._id === caseFilter._id
      : true;
    const matchesOwnerFilter = ownerFilter
      ? timesheet.owner._id === ownerFilter._id
      : true;
    const matchesStatusFilter = statusFilter
      ? timesheet.isBilled === (statusFilter === "Billed")
      : true;

    const matchesBillingPeriod =
      billingPeriod[0] && billingPeriod[1]
        ? new Date(timesheet.date) >= billingPeriod[0] &&
          new Date(timesheet.date) <= billingPeriod[1]
        : true;

    return (
      userFiles.some((file) => file._id === timesheet.fileCase?._id) &&
      matchesSearchTerm &&
      matchesCaseFilter &&
      matchesOwnerFilter &&
      matchesStatusFilter &&
      matchesBillingPeriod
    );
  });

  const sortedTimesheets = filteredTimesheets.sort((a, b) => {
    if (orderBy) {
      let aValue = a[orderBy];
      let bValue = b[orderBy];

      if (orderBy === "owner") {
        aValue = a.owner
          ? `${a.owner.firstName} ${a.owner.middleName || ""} ${
              a.owner.lastName
            }`.trim()
          : "";
        bValue = b.owner
          ? `${b.owner.firstName} ${b.owner.middleName || ""} ${
              b.owner.lastName
            }`.trim()
          : "";
      } else if (orderBy === "fileCase") {
        aValue = a.fileCase ? a.fileCase.name : "";
        bValue = b.fileCase ? b.fileCase.name : "";
      }

      if (order === "asc") {
        return aValue < bValue ? -1 : 1;
      } else {
        return aValue > bValue ? -1 : 1;
      }
    }
    return 0;
  });

  const StringToColor = (string) => {
    if (!string) return "#ccc"; // Default gray color if string is empty

    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += ("00" + value.toString(16)).slice(-2);
    }

    return color;
  };

  return (
    <Container>
      <Box
        sx={{
          minHeight: "auto",
          height: "auto",
          backgroundColor: "#fff", // Add white background here
          "& .MuiTab-root": {
            fontFamily:
              "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
            color: "#252525",
            minHeight: "32px",
            height: "32px",
            textTransform: "capitalize", // Capitalize first letter
            fontSize: "10.5px",
            fontWeight: "400",
          },
          "& .Mui-selected": {
            color: "#2B80B6",
            borderBottom: "2px solid #2B80B6",
          },
          // marginBottom:"1rem"
        }}
      >
        <Typography
          sx={{
            fontFamily:
              "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
            fontWeight: "700",
            fontSize: "20px",
            paddingX: "12px",
            paddingY: "12px",
            color: "rgb(53, 53, 53)",
          }}
        >
          {t('pages:search.results_for')} "{searchTerm}"
        </Typography>
      </Box>
      {/* Tabs Section */}
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        aria-label="search result tabs"
        sx={{
          minHeight: "32px",
          height: "32px",
          backgroundColor: "#fff",
          "& .MuiTab-root": {
            fontFamily:
              "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
            color: "#353535",
            minHeight: "32px",
            height: "32px",
            textTransform: "capitalize",
            fontSize: "10.5px",
            fontWeight: "400",

            paddingLeft: "13px",
          },
          "& .Mui-selected": {
            color: "#005B92",
            borderBottom: "2px solid #2B80B6",
            opacity: "1 !important",
          },
          paddingLeft: "1.5rem",
          // paddingRight:"2rem"
        }}
      >
        {[
          { label: t('common:files'), count: filteredFiles.length },
          { label: t('pages:relationships.title'), count: filteredRelationships.length },
          { label: t('pages:documents.title'), count: filteredDocuments.length },
          { label: t('common:timesheets'), count: filteredTimesheets.length },
          { label: t('common:tasks'), count: filteredTasks.length },
          { label: t('pages:appointments.title'), count: filteredAppointments.length },
        ].map((tab, index) => (
          <Tab
            key={tab.label}
            label={
              <Box display="flex" alignItems="center" gap={1.5}>
                <span
                  style={{
                    opacity: "0.5",
                    marginRight: tab.label === "Timesheets" ? "4px" : "4px",
                    // tab.label === "Timesheets" ? { marginRight: "3px" } : {}
                  }}
                >
                  {tab.label}
                </span>
                <Badge
                  badgeContent={tab.count}
                  sx={{
                    "& .MuiBadge-badge": {
                      fontFamily: "Fira Sans, Helvetica, Arial, sans-serif",
                      backgroundColor: tabValue === index ? "#005B92" : "black",
                      color: "white",
                      minWidth: "20px",
                      height: "12px", // Increase height slightly
                      borderRadius: "10px",
                      fontSize: "7px",
                      padding: "0 6px", // Keep padding balanced
                      opacity: "1",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      lineHeight: "14px", // Add line-height to center text
                    },
                  }}
                />
              </Box>
            }
          />
        ))}
      </Tabs>

      {tabValue === 0 && (
        <>
          <Container
            maxWidth="lg"
            sx={{
              backgroundColor: "white",
              boxShadow: "0px 4px 16px rgba(0,0,0,0.013)", // Reduced shadow spread
              pt: 2,
              marginBottom: 8,
              // marginTop: ,
            }}
          >
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0",
                margin: "0",
                mb: 4,
                mt: 2,
                gap: 2,
              }}
            >
              <BreadcrumbNav title="Files" />
            </Box> */}

            <Box>
              {filteredFiles.length > 0 ? (
                <TableContainer>
                  <Table sx={tableStyles.container} size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={tableStyles.headerCell}>#</TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "fileNo"}
                            direction={orderBy === "fileNo" ? order : "asc"}
                            onClick={() => handleRequestSort("fileNo")}
                          >
                            File No.
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "name"}
                            direction={orderBy === "name" ? order : "asc"}
                            onClick={() => handleRequestSort("name")}
                          >
                            File Name
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "responsibleLawyer"}
                            direction={
                              orderBy === "responsibleLawyer" ? order : "asc"
                            }
                            onClick={() =>
                              handleRequestSort("responsibleLawyer")
                            }
                          >
                            Responsible Lawyer
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "treatingLawyer"}
                            direction={
                              orderBy === "treatingLawyer" ? order : "asc"
                            }
                            onClick={() => handleRequestSort("treatingLawyer")}
                          >
                            Treating Lawyer
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "clientName"}
                            direction={orderBy === "clientName" ? order : "asc"}
                            onClick={() => handleRequestSort("clientName")}
                          >
                            Client Name
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "type"}
                            direction={orderBy === "type" ? order : "asc"}
                            onClick={() => handleRequestSort("type")}
                          >
                            Jurisdiction
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "status"}
                            direction={orderBy === "status" ? order : "asc"}
                            onClick={() => handleRequestSort("status")}
                          >
                            Status
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>Notes</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortedFiles
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((file, index) => (
                          <TableRow key={file._id} sx={{ ...tableStyles.row }}>
                            <TableCell sx={tableStyles.cell}>
                              {page * rowsPerPage + index + 1}
                            </TableCell>
                            <TableCell
                              onClick={() =>
                                navigate(`/files/${file._id}/overview`)
                              }
                              sx={{
                                ...tableStyles.cell,
                                cursor: "pointer",
                                "&:hover": {
                                  textDecoration: "underline !important",
                                },
                                color: "#005b92",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                }}
                              >
                                <FolderOpenOutlinedIcon
                                  sx={{ fontSize: "1rem", color: "#005b92" }}
                                />
                                <span style={{ marginTop: "1px" }}>
                                  {file.fileNo}
                                </span>
                              </Box>
                            </TableCell>

                            <TableCell
                              onClick={() =>
                                navigate(`/files/${file._id}/overview`)
                              }
                              sx={{
                                ...tableStyles.cell,
                                // padding: "8px",
                                fontSize: "10.5px",
                                cursor: "pointer",
                                "&:hover": {
                                  textDecoration: "underline !important",
                                  cursor: "pointer",
                                },
                                color: "#005b92",
                                minHeight: "10px 1important",
                              }}
                            >
                              {file.name}
                            </TableCell>

                            <TableCell
                              sx={{
                                ...tableStyles.cell,
                              }}
                              // onClick={() => navigate(`/relationships/${file.officeMembers.find(member => member.role === "Responsible Lawyer").member?._id}`)}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <Avatar
                                  alt={
                                    file.officeMembers.find(
                                      (member) =>
                                        member.role === "Responsible Lawyer"
                                    ).member?.firstName
                                  }
                                  src={
                                    file.officeMembers.find(
                                      (member) =>
                                        member.role === "Responsible Lawyer"
                                    ).member?.avatar
                                      ? file.officeMembers.find(
                                          (member) =>
                                            member.role === "Responsible Lawyer"
                                        ).member?.avatar
                                      : "/static/images/avatar/1.jpg"
                                  }
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                  }}
                                />
                                <Box
                                  sx={{
                                    // color: "rgb(53, 53, 53)",
                                    // color: "#005b92",
                                    display: "block",
                                    fontFamily:
                                      '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                                    fontSize: "10.5px",
                                    fontWeight: 400,
                                    height: "13.5px",
                                    lineHeight: "13.5px",
                                    marginLeft: "-3px",
                                  }}
                                >
                                  {file.officeMembers.find(
                                    (member) =>
                                      member.role === "Responsible Lawyer"
                                  )
                                    ? (() => {
                                        const responsibleLawyer =
                                          file.officeMembers.find(
                                            (member) =>
                                              member.role ===
                                              "Responsible Lawyer"
                                          ).member;
                                        return `${
                                          responsibleLawyer.firstName
                                        } ${
                                          responsibleLawyer.middleName
                                            ? responsibleLawyer.middleName + " "
                                            : ""
                                        }${responsibleLawyer.lastName}`;
                                      })()
                                    : "N/A"}
                                </Box>
                              </Box>
                            </TableCell>

                            <TableCell sx={tableStyles.cell}>
                              {file.officeMembers.find(
                                (member) => member.role === "Treating Lawyer"
                              )
                                ? (() => {
                                    const treatingLawyer =
                                      file.officeMembers.find(
                                        (member) =>
                                          member.role === "Treating Lawyer"
                                      ).member;
                                    return `${treatingLawyer.uniqueNumber} - ${
                                      treatingLawyer.firstName
                                    } ${
                                      treatingLawyer.middleName
                                        ? treatingLawyer.middleName + " "
                                        : ""
                                    }${treatingLawyer.lastName}`;
                                  })()
                                : "N/A"}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...tableStyles.cell,
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                navigate(
                                  `/relationships/${
                                    file.parties.find(
                                      (member) => member.role === "Client"
                                    )?.member?._id
                                  }`
                                )
                              }
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <Avatar
                                  alt={
                                    file.parties.find(
                                      (party) => party.type === "Client"
                                    )?.name?.businessName || "Client"
                                  }
                                  src={
                                    file.parties.find(
                                      (party) => party.type === "Client"
                                    )?.name?.avatar ||
                                    "/static/images/avatar/1.jpg"
                                  }
                                  sx={{
                                    width: "16px",
                                    height: "16px",
                                    fontSize: "7.8px",
                                  }}
                                />
                                {console.log(
                                  "avatar is",
                                  file.parties.find(
                                    (party) => party.type === "Client"
                                  )?.member?.avatar
                                )}
                                <Box
                                  sx={{
                                    // color: "rgb(53, 53, 53)",
                                    color: "#005b92",
                                    display: "block",
                                    height: "13.5px",
                                    lineHeight: "13.5px",
                                    "&:hover": {
                                      textDecoration: "underline !important",
                                      cursor: "pointer",
                                    },
                                    marginLeft: "-3px",
                                  }}
                                >
                                  {file.parties.find(
                                    (party) => party.type === "Client"
                                  )
                                    ? (() => {
                                        const client = file.parties.find(
                                          (party) => party.type === "Client"
                                        ).name;
                                        if (
                                          client.contractType === "Individual"
                                        ) {
                                          return `${client.firstName} ${
                                            client.middleName
                                              ? client.middleName + " "
                                              : ""
                                          }${client.lastName}`;
                                        } else if (
                                          client.contractType === "Company"
                                        ) {
                                          return `${client.businessName}`;
                                        } else {
                                          return "N/A";
                                        }
                                      })()
                                    : "N/A"}
                                </Box>
                              </Box>
                            </TableCell>

                            <TableCell sx={tableStyles.cell}>
                              {translateType(file.type)}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...tableStyles.cell,
                                padding: "4px",
                                fontSize: "10.5px",
                              }}
                            >
                              <span
                                style={{
                                  padding: "1px 6px",
                                  borderRadius: "20px",
                                  backgroundColor:
                                    file.status === "Active"
                                      ? "#85bc20"
                                      : file.status === "Inactive"
                                      ? "#e5202e"
                                      : "transparent",
                                  color:
                                    file.status === "Inactive"
                                      ? "white"
                                      : "black",
                                  fontSize: "8.25px",
                                  fontFamily:
                                    '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                                  fontWeight: "700",
                                  textTransform: "upperCase",
                                  height: "12px",
                                  letterSpacing: "0.2em",
                                  // display: "inline-block",
                                }}
                              >
                                {translateStatus(file.status)}
                              </span>
                            </TableCell>

                            <TableCell sx={tableStyles.cell}>
                              <IconButton
                                onClick={() => handleOpenNotes(file)}
                                sx={{
                                  width: "16px",
                                  height: "16px",
                                  padding: 0,
                                }}
                              >
                                {file.notes && file.notes.length > 0 ? (
                                  <NoteIcon sx={{ fontSize: "20px" }} />
                                ) : (
                                  <NoteOutlinedIcon sx={{ fontSize: "20px" }} />
                                )}
                              </IconButton>
                              <NotesDialog
                                selectedFile={selectedFile}
                                file={file}
                                notes={notes}
                                newNote={newNote}
                                newNoteDate={newNoteDate}
                                showNewNoteField={showNewNoteField}
                                snackbarOpen={snackbarOpen}
                                snackbarMessage={snackbarMessage}
                                handleCloseNotes={handleCloseNotes}
                                handleAddNote={handleAddNote}
                                handleSaveAllNotes={handleSaveAllNotes}
                                handleDeleteNote={handleDeleteNote}
                                setNewNote={setNewNote}
                                setShowNewNoteField={setShowNewNoteField}
                                setNotes={setNotes}
                                setSnackbarOpen={setSnackbarOpen}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                  <TablePagination
                    component="div"
                    count={filteredFiles.length}
                    page={page}
                    onPageChange={handlePageChange}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleRowsPerPageChange}
                  />
                </TableContainer>
              ) : (
                <Box
                  sx={{
                    ...smallTitle,
                    padding: "32px 24px",
                    textAlign: "center",
                  }}
                >
                  {t('common:no_data_available')}
                </Box>
              )}
            </Box>

            {/* <Snackbar
                                open={snackbarOpen}
                                autoHideDuration={6000}
                                onClose={handleSnackbarClose}
                            >
                                <SnackbarContent
                                    message={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            <CheckCircleIcon style={{ marginRight: "8px" }} />
                                            {snackbarMessage}
                                        </span>
                                    }
                                    style={{
                                        backgroundColor:
                                            snackbarSeverity === "success" ? "#d4edda" : "#f8d7da",
                                        color: snackbarSeverity === "success" ? "#155724" : "#721c24",
                                    }}
                                    action={
                                        <Button color="inherit" size="small" onClick={handleSnackbarClose}>
                                            Close
                                        </Button>
                                    }
                                />
                            </Snackbar> */}
          </Container>
        </>
      )}

      {tabValue === 1 && (
        <>
          <Container
            maxWidth="lg"
            sx={{
              backgroundColor: "white",
              boxShadow: "0px 4px 16px rgba(0,0,0,0.013)", // Reduced shadow spread
              pt: 2,
              marginBottom: 8,
              // marginTop: 2,
            }}
          >
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0",
                margin: "0",
                mb: 4,
                mt: 2,
                gap: 2,
              }}
            >
              <BreadcrumbNav title="Relationships" breadcrumbs={breadcrumbs} />
            </Box> */}

            <Box>
              {filteredRelationships?.length > 0 ? (
                <TableContainer>
                  <Table sx={tableStyles.container} size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "uniqueNumber"}
                            direction={
                              orderBy === "uniqueNumber" ? order : "asc"
                            }
                            onClick={() => handleRequestSort("uniqueNumber")}
                          >
                            ID
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "name"}
                            direction={orderBy === "name" ? order : "asc"}
                            onClick={() => handleRequestSort("name")}
                          >
                            Name
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "type"}
                            direction={orderBy === "type" ? order : "asc"}
                            onClick={() => handleRequestSort("type")}
                          >
                            Type
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "status"}
                            direction={orderBy === "status" ? order : "asc"}
                            onClick={() => handleRequestSort("status")}
                          >
                            Status
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "phone"}
                            direction={orderBy === "phone" ? order : "asc"}
                            onClick={() => handleRequestSort("phone")}
                          >
                            Phone
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "email"}
                            direction={orderBy === "email" ? order : "asc"}
                            onClick={() => handleRequestSort("email")}
                          >
                            Email
                          </TableSortLabel>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortedRelationships
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((relationship) => (
                          <TableRow
                            key={relationship._id}
                            sx={{ ...tableStyles.row }}
                          >
                            <TableCell sx={tableStyles.cell}>
                              {relationship.uniqueNumber}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...tableStyles.cell,
                                color: "#005b92",
                              }}
                              onClick={() =>
                                navigate(`/relationships/${relationship._id}`)
                              }
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <Avatar
                                  alt={
                                    relationship?.firstName ||
                                    relationship?.businessName
                                  }
                                  src={
                                    relationship.avatar
                                      ? relationship.avatar
                                      : ""
                                  }
                                  sx={{
                                    // fontFamily: '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                                    fontSize: "7.8px",
                                    height: "1rem",
                                    width: "1rem",
                                    marginRight: "0.2rem",
                                    fontWeight: "bold",
                                    // backgroundColor: relationship.avatar
                                    //   ? "transparent"
                                    //   : stringToColor(relationship.firstName || relationship.businessName),
                                    color: "#fff",
                                    // fontWeight: relationship?.businessName ? "600" : "400"
                                  }}
                                >
                                  {!relationship.avatar && (
                                    <>
                                      {relationship.firstName
                                        ? relationship.firstName.charAt(0)
                                        : ""}
                                      {relationship.businessName
                                        ? relationship.businessName.charAt(0)
                                        : relationship.lastName
                                        ? relationship.lastName.charAt(0)
                                        : ""}
                                    </>
                                  )}
                                </Avatar>
                                <Box
                                  component="span" // Render as a `span` element
                                  sx={{
                                    "&:hover": {
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    },
                                    marginLeft: "-3px",
                                  }}
                                >
                                  {relationship.contractType === "Individual"
                                    ? `${relationship.firstName || ""} ${
                                        relationship.middleName || ""
                                      } ${relationship.lastName || ""}`
                                    : relationship.businessName || ""}
                                </Box>
                              </Box>
                            </TableCell>

                            <TableCell sx={tableStyles.cell}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                {relationship.contractType === "Individual" ? (
                                  <PersonOutlineIcon
                                    sx={{ fontSize: "1.2rem", color: "gray" }}
                                  />
                                ) : (
                                  <BusinessOutlinedIcon
                                    sx={{ fontSize: "1.2rem", color: "gray" }}
                                  />
                                )}
                              </Box>
                            </TableCell>
                            <TableCell sx={tableStyles.cell}>
                              <span
                                style={{
                                  padding: "1px 6px",
                                  borderRadius: "20px",
                                  backgroundColor:
                                    relationship.status === "Active"
                                      ? "#85bc20"
                                      : relationship.status === "Inactive"
                                      ? "#e5202e"
                                      : "transparent",
                                  color:
                                    relationship.status === "Inactive"
                                      ? "white"
                                      : "black",
                                  fontSize: "8.25px",
                                  fontFamily:
                                    '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                                  fontWeight: "700",
                                  textTransform: "upperCase",
                                  height: "12px",
                                  letterSpacing: "0.2em",
                                  // display: "inline-block",
                                }}
                              >
                                {relationship.status}
                              </span>
                            </TableCell>
                            <TableCell
                              sx={{
                                ...tableStyles.cell,
                                "&:hover": {
                                  textDecoration: "underline !important",
                                  cursor: "pointer",
                                },
                                color: "#005b92",
                              }}
                            >
                              {relationship.contacts &&
                              relationship.contacts.length > 0
                                ? relationship.contacts[0].phone
                                : ""}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...tableStyles.cell,
                                "&:hover": {
                                  textDecoration: "underline !important",
                                  cursor: "pointer",
                                },
                                color: "#005b92",
                              }}
                            >
                              {relationship.contacts &&
                              relationship.contacts.length > 0
                                ? relationship.contacts[0].email
                                : ""}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                  <TablePagination
                    component="div"
                    count={sortedRelationships?.length}
                    page={page}
                    onPageChange={handlePageChange}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleRowsPerPageChange}
                  />
                </TableContainer>
              ) : (
                <Box
                  sx={{
                    ...smallTitle,
                    padding: "32px 24px",
                    textAlign: "center",
                  }}
                >
                  No data available
                </Box>
              )}
            </Box>
          </Container>
        </>
      )}

      {tabValue === 2 && (
        <>
          <Container
            maxWidth="lg"
            sx={{
              backgroundColor: "white",
              boxShadow: "0px 4px 16px rgba(0,0,0,0.013)", // Reduced shadow spread
              pt: 2,
              marginBottom: 8,
              // marginTop: 2,
            }}
          >
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0",
                margin: "0",
                mb: 4,
                mt: 2,
                gap: 2,
              }}
            >
              <BreadcrumbNav title="Documents" />

              <Button
                startIcon={<AddIcon />}
                onClick={() => navigate("/documents/upload")}
                size="small"
                sx={actionButtonStyles()}
              >
                Upload Document
              </Button>
            </Box> */}

            <Box>
              <TableContainer>
                {filteredDocuments?.length > 0 ? (
                  <Table sx={tableStyles.container} size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "title"}
                            direction={orderBy === "title" ? order : "asc"}
                            onClick={() => handleRequestSort("title")}
                          >
                            Title
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "type"}
                            direction={orderBy === "type" ? order : "asc"}
                            onClick={() => handleRequestSort("type")}
                          >
                            Type
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "folder"}
                            direction={orderBy === "folder" ? order : "asc"}
                            onClick={() => handleRequestSort("folder")}
                          >
                            Folder
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "caseFile"}
                            direction={orderBy === "caseFile" ? order : "asc"}
                            onClick={() => handleRequestSort("caseFile")}
                          >
                            Case File
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "owner"}
                            direction={orderBy === "owner" ? order : "asc"}
                            onClick={() => handleRequestSort("owner")}
                          >
                            Owner
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          <TableSortLabel
                            active={orderBy === "modifiedDate"}
                            direction={
                              orderBy === "modifiedDate" ? order : "asc"
                            }
                            onClick={() => handleRequestSort("modifiedDate")}
                          >
                            Modified Date
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={tableStyles.headerCell}>
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paginatedDocuments.map((document) => (
                        <TableRow
                          key={document._id}
                          sx={{ ...tableStyles.row }}
                        >
                          <TableCell sx={tableStyles.cell}>
                            {document.title}
                          </TableCell>
                          <TableCell sx={tableStyles.cell}>
                            {document.type === "pdf" && (
                              <Box
                                sx={{
                                  width: "20px",
                                  height: "20px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <PictureAsPdfIcon
                                  sx={{ color: "#E32636", fontSize: "20px" }}
                                />
                              </Box>
                            )}
                            {document.type === "word" && (
                              <Box
                                sx={{
                                  width: "20px",
                                  height: "20px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <MicrosoftWordIcon sx={{ fontSize: "20px" }} />
                              </Box>
                            )}
                            {document.type === "text" && (
                              <Box
                                sx={{
                                  width: "20px",
                                  height: "20px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <TextSnippetIcon sx={{ fontSize: "20px" }} />
                              </Box>
                            )}
                            {document.type !== "pdf" &&
                              document.type !== "word" &&
                              document.type !== "text" && (
                                <Box
                                  sx={{
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <DescriptionIcon sx={{ fontSize: "20px" }} />
                                </Box>
                              )}
                          </TableCell>

                          <TableCell sx={tableStyles.cell}>
                            {document.folder}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...tableStyles.cell,
                              "&:hover": {
                                cursor: "pointer",
                                textDecoration: "underline",
                              },
                              color: "#005b92",
                            }}
                            onClick={() =>
                              navigate(
                                `/files/${document?.caseFile._id}/overview`
                              )
                            }
                          >
                            {document.caseFile.name}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...tableStyles.cell,
                              "&:hover": {
                                cursor: "pointer",
                                textDecoration: "underline",
                              },
                              color: "#005b92",
                            }}
                            onClick={() => {
                              navigate(
                                `/relationships/${document?.owner?._id}`
                              );
                            }}
                          >
                            {document.owner ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <Avatar
                                  alt={
                                    document.owner.firstName &&
                                    document.owner.lastName
                                      ? `${document.owner.firstName} ${document.owner.lastName}`
                                      : "N/A"
                                  }
                                  src={
                                    document.owner.avatar ||
                                    "/static/images/avatar/1.jpg"
                                  }
                                  sx={{
                                    fontFamily:
                                      '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                                    fontSize: "7.8px",
                                    height: "1rem",
                                    width: "1rem",
                                    marginRight: "-2px",
                                  }}
                                />
                                {document.owner.businessName ||
                                  `${document.owner.firstName} ${document.owner.lastName}`.trim() ||
                                  "--"}
                              </Box>
                            ) : (
                              "--"
                            )}
                          </TableCell>

                          <TableCell sx={tableStyles.cell}>
                            {new Date(
                              document.modifiedDate
                            ).toLocaleDateString()}
                          </TableCell>
                          <TableCell sx={tableStyles.cell}>
                            <Box display="flex">
                              <Tooltip title="View Document">
                                <IconButton
                                  onClick={() => handleView(document._id)}
                                  sx={{
                                    width: "20px",
                                    height: "20px",
                                    marginX: "8px",
                                    color: "#005b92",
                                  }}
                                >
                                  <VisibilityIcon sx={{ fontSize: "20px" }} />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Update Document">
                                <IconButton
                                  onClick={() =>
                                    handleUpdateDocument(document._id)
                                  }
                                  sx={{
                                    width: "20px",
                                    height: "20px",
                                    marginX: "8px",
                                    color: "#005b92",
                                  }}
                                >
                                  <EditIcon sx={{ fontSize: "20px" }} />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={t('buttons:primary.download')}>
                                <IconButton
                                  onClick={() => handleDownload(document._id)}
                                  sx={{
                                    width: "20px",
                                    height: "20px",
                                    marginX: "8px",
                                    color: "#005b92",
                                  }}
                                >
                                  <DownloadIcon sx={{ fontSize: "20px" }} />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={t('buttons:primary.send_email')}>
                                <IconButton
                                  onClick={() => handleSendEmail(document._id)}
                                  sx={{
                                    width: "20px",
                                    height: "20px",
                                    marginX: "8px",
                                    color: "#005b92",
                                  }}
                                >
                                  <SendIcon sx={{ fontSize: "20px" }} />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Box
                    sx={{
                      ...smallTitle,
                      padding: "32px 24px",
                      textAlign: "center",
                    }}
                  >
                    No data available
                  </Box>
                )}
                <TablePagination
                  component="div"
                  count={filteredDocuments.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </Box>
          </Container>
        </>
      )}

      {tabValue === 3 && (
        <>
          <Container
            maxWidth="lg"
            sx={{
              backgroundColor: "white",
              boxShadow: "0px 4px 16px rgba(0,0,0,0.013)", // Reduced shadow spread
              pt: 2,
              marginBottom: 8,
              // marginTop: 2,
            }}
          >
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0",
                margin: "0",
                mb: 4,
                mt: 2,
                gap: 2,
              }}
            >
              <BreadcrumbNav title="Timesheets" breadcrumbs={breadcrumbs} />
            </Box> */}

            <Box
              sx={{
                // padding: "20px",
                boxShadow:
                  "2px 2px 6px rgba(255,255,255,0.3), -2px -2px 6px rgba(255,255,255,0.3)", // Reduced shadow spread
              }}
            >
              {loading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "32px 24px",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <Box>
                  <TableContainer>
                    {delayedCheck && filteredTimesheet?.length === 0 ? (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          padding: "32px 24px",
                        }}
                      >
                        {t('common:no_data_available')}.
                      </Box>
                    ) : (
                      <Table sx={tableStyles.container} size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={tableStyles.headerCell}>#</TableCell>
                            <TableCell
                              sx={{ ...tableStyles.headerCell, width: "250px" }}
                            >
                              <TableSortLabel
                                active={orderBy === "type"}
                                direction={orderBy === "type" ? order : "asc"}
                                onClick={() => handleRequestSort("type")}
                              >
                                Type
                              </TableSortLabel>
                            </TableCell>
                            <TableCell
                              sx={{ ...tableStyles.headerCell, width: "150px" }}
                            >
                              <TableSortLabel
                                active={orderBy === "owner"}
                                direction={orderBy === "owner" ? order : "asc"}
                                onClick={() => handleRequestSort("owner")}
                              >
                                Owner
                              </TableSortLabel>
                            </TableCell>
                            <TableCell
                              sx={{ ...tableStyles.headerCell, width: "100px" }}
                            >
                              <TableSortLabel
                                active={orderBy === "date"}
                                direction={orderBy === "date" ? order : "asc"}
                                onClick={() => handleRequestSort("date")}
                              >
                                Date
                              </TableSortLabel>
                            </TableCell>
                            <TableCell
                              sx={{ ...tableStyles.headerCell, width: "250px" }}
                            >
                              <TableSortLabel
                                active={orderBy === "fileCase"}
                                direction={
                                  orderBy === "fileCase" ? order : "asc"
                                }
                                onClick={() => handleRequestSort("fileCase")}
                              >
                                Case
                              </TableSortLabel>
                            </TableCell>
                            <TableCell
                              sx={{ ...tableStyles.headerCell, width: "100px" }}
                            >
                              <TableSortLabel
                                active={orderBy === "isBilled"}
                                direction={
                                  orderBy === "isBilled" ? order : "asc"
                                }
                                onClick={() => handleRequestSort("isBilled")}
                              >
                                Status
                              </TableSortLabel>
                            </TableCell>
                            <TableCell
                              sx={{ ...tableStyles.headerCell, width: "150px" }}
                            >
                              <TableSortLabel
                                active={orderBy === "client"}
                                direction={orderBy === "client" ? order : "asc"}
                                onClick={() => handleRequestSort("client")}
                              >
                                Client
                              </TableSortLabel>
                            </TableCell>
                            <TableCell
                              sx={{ ...tableStyles.headerCell, width: "120px" }}
                            >
                              <TableSortLabel
                                active={orderBy === "totalDuration"}
                                direction={
                                  orderBy === "totalDuration" ? order : "asc"
                                }
                                onClick={() =>
                                  handleRequestSort("totalDuration")
                                }
                              >
                                Time
                              </TableSortLabel>
                            </TableCell>
                            <TableCell
                              sx={{ ...tableStyles.headerCell, width: "120px" }}
                            >
                              <TableSortLabel
                                active={orderBy === "totalAmount"}
                                direction={
                                  orderBy === "totalAmount" ? order : "asc"
                                }
                                onClick={() => handleRequestSort("totalAmount")}
                              >
                                Total Amount
                              </TableSortLabel>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {sortedTimesheets
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((timesheet, index) => (
                              <TableRow
                                key={timesheet._id}
                                sx={{ ...tableStyles.row }}
                              >
                                <TableCell sx={tableStyles.cell}>
                                  {page * rowsPerPage + index + 1}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...tableStyles.cell,
                                    "&:hover": {
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    },
                                    color: "#005b92",
                                    lineHeight: "12px",
                                  }}
                                  onClick={() =>
                                    navigate(`/timesheets/${timesheet._id}`)
                                  }
                                >
                                  {truncateText(timesheet.type, 50)}
                                </TableCell>
                                <TableCell
                                  sx={{ ...tableStyles.cell }}
                                  // onClick={()=>{navigate(`/relationships/${timesheet?.owner?._id}`);}}
                                >
                                  {timesheet.owner ? (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                      }}
                                    >
                                      <Avatar
                                        alt={`${timesheet.owner.firstName} ${timesheet.owner.lastName}`}
                                        src={
                                          timesheet.owner.avatar ||
                                          "/static/images/avatar/1.jpg"
                                        } // Default avatar if none is provided
                                        sx={{
                                          width: "1rem", // Adjust size of the avatar
                                          height: "1rem",
                                          fontSize: "8px",
                                        }}
                                      >
                                        {/* Show the first letter of first or middle name (fallback to last name if no middle name) */}
                                        {!timesheet.owner.avatar &&
                                          `${timesheet.owner.firstName.charAt(
                                            0
                                          )}${
                                            timesheet.owner.middleName
                                              ? timesheet.owner.middleName.charAt(
                                                  0
                                                )
                                              : timesheet.owner.lastName.charAt(
                                                  0
                                                )
                                          }`}
                                      </Avatar>
                                      <span>
                                        {`${timesheet.owner.firstName} ${
                                          timesheet.owner.middleName
                                            ? timesheet.owner.middleName + " "
                                            : ""
                                        }${timesheet.owner.lastName}`}
                                      </span>
                                    </Box>
                                  ) : (
                                    "No owner"
                                  )}
                                </TableCell>

                                <TableCell sx={tableStyles.cell}>
                                  {new Date(
                                    timesheet.date
                                  ).toLocaleDateString()}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...tableStyles.cell,
                                    "&:hover": {
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    },
                                    color: "#005b92",
                                  }}
                                  onClick={() =>
                                    navigate(
                                      `/files/${timesheet.fileCase._id}/overview`
                                    )
                                  }
                                >
                                  {timesheet.fileCase ? (
                                    <>
                                      <Stack direction="row">
                                        <Typography
                                          variant="caption"
                                          // color="textSecondary"
                                          sx={{ fontSize: "0.7rem" }} // Smaller font size
                                        >
                                          {timesheet.fileCase.fileNo}
                                        </Typography>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            fontWeight: "bold",
                                            fontSize: "0.8rem",
                                            marginTop: "-2.5px",
                                            marginLeft: "4px",
                                          }} // Smaller font size
                                        >
                                          {truncateText(
                                            timesheet.fileCase.name,
                                            30
                                          )}
                                        </Typography>
                                      </Stack>
                                    </>
                                  ) : (
                                    "No case"
                                  )}
                                </TableCell>
                                <TableCell sx={tableStyles.cell}>
                                  <span
                                    style={{
                                      padding: "1px 6px",
                                      borderRadius: "20px",
                                      backgroundColor: timesheet.isBilled
                                        ? "#85bc20"
                                        : "#e5202e", // Green for Billed, Red for Not Billed
                                      color: timesheet.isBilled
                                        ? "black"
                                        : "white",
                                      fontSize: "8.25px",
                                      fontFamily:
                                        '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                                      fontWeight: "700",
                                      textTransform: "upperCase",
                                      height: "12px",
                                      letterSpacing: "0.2em",
                                    }}
                                  >
                                    {timesheet.isBilled
                                      ? "Billed"
                                      : "Not billed"}
                                  </span>
                                </TableCell>

                                <TableCell
                                  sx={{
                                    ...tableStyles.cell,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    <Avatar
                                      alt={
                                        timesheet.fileCase.parties.find(
                                          (party) => party.type === "Client"
                                        )?.name?.businessName || "N/A"
                                      }
                                      src={
                                        timesheet.fileCase.parties.find(
                                          (party) => party.type === "Client"
                                        )?.name?.avatar ||
                                        "/static/images/avatar/1.jpg"
                                      }
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        marginRight: "3px",
                                      }}
                                    />
                                    <Box
                                      sx={{
                                        display: "block",
                                        fontFamily:
                                          '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                                        fontSize: "10.5px",
                                        fontWeight: 400,
                                        height: "13.5px",
                                        lineHeight: "13.5px",
                                        marginLeft: "-3px",
                                      }}
                                    >
                                      {(() => {
                                        const client =
                                          timesheet.fileCase.parties.find(
                                            (party) => party.type === "Client"
                                          )?.name;

                                        return client
                                          ? client.businessName ||
                                              `${client.firstName || ""} ${
                                                client.lastName || ""
                                              }`.trim()
                                          : "N/A";
                                      })()}
                                    </Box>
                                  </Box>
                                </TableCell>

                                <TableCell sx={tableStyles.cell}>
                                  {convertToDecimalHours(
                                    timesheet.totalDuration
                                  )}{" "}
                                  h
                                </TableCell>

                                <TableCell sx={tableStyles.cell}>
                                  {timesheet.totalAmount}
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    )}
                    <TablePagination
                      component="div"
                      count={filteredTimesheets.length}
                      page={page}
                      onPageChange={handlePageChange}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleRowsPerPageChange}
                      sx={{ borderTop: "1px solid #ddd", padding: "10px" }}
                    />
                  </TableContainer>
                </Box>
              )}
            </Box>
          </Container>
        </>
      )}

      {tabValue === 4 && (
        <>
          <Container
            maxWidth="lg"
            sx={{
              backgroundColor: "white",
              boxShadow: "0px 4px 16px rgba(0,0,0,0.013)", // Reduced shadow spread
              pt: 2,
              marginBottom: 8,
              // marginTop: 2,
            }}
          >
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0",
                margin: "0",
                mb: 4,
                mt: 2,
                gap: 2,
              }}
            >
              <BreadcrumbNav title="Tasks" breadcrumbs={breadcrumbs} />
            </Box> */}

            <Box>
              <TableContainer>
                {delayedCheck && filteredTask?.length === 0 ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "32px 24px",
                    }}
                  >
                    No data available
                  </Box>
                ) : (
                  <Table sx={tableStyles.container} size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={tableStyles.headerCell}>#</TableCell>
                        <TableCell
                          sx={{ ...tableStyles.headerCell, width: "150px" }}
                        >
                          <TableSortLabel
                            active={orderBy === "owner"}
                            direction={orderBy === "owner" ? order : "asc"}
                            onClick={() => handleRequestSort("owner")}
                          >
                            Owner
                          </TableSortLabel>
                        </TableCell>

                        <TableCell
                          sx={{ ...tableStyles.headerCell, width: "150px" }}
                        >
                          <TableSortLabel
                            active={orderBy === "type"}
                            direction={orderBy === "type" ? order : "asc"}
                            onClick={() => handleRequestSort("type")}
                          >
                            Type
                          </TableSortLabel>
                        </TableCell>
                        <TableCell
                          sx={{ ...tableStyles.headerCell, width: "150px" }}
                        >
                          <TableSortLabel
                            active={orderBy === "owner"}
                            direction={orderBy === "owner" ? order : "asc"}
                            onClick={() => handleRequestSort("client")}
                          >
                            Client
                          </TableSortLabel>
                        </TableCell>
                        <TableCell
                          sx={{ ...tableStyles.headerCell, width: "200px" }}
                        >
                          <TableSortLabel
                            active={orderBy === "case"}
                            direction={orderBy === "case" ? order : "asc"}
                            onClick={() => handleRequestSort("case")}
                          >
                            Case
                          </TableSortLabel>
                        </TableCell>
                        <TableCell
                          sx={{ ...tableStyles.headerCell, width: "150px" }}
                        >
                          <TableSortLabel
                            active={orderBy === "subject"}
                            direction={orderBy === "subject" ? order : "asc"}
                            onClick={() => handleRequestSort("subject")}
                          >
                            Subject
                          </TableSortLabel>
                        </TableCell>
                        <TableCell
                          sx={{ ...tableStyles.headerCell, width: "100px" }}
                        >
                          <TableSortLabel
                            active={orderBy === "dueDate"}
                            direction={orderBy === "dueDate" ? order : "asc"}
                            onClick={() => handleRequestSort("dueDate")}
                          >
                            Due Date
                          </TableSortLabel>
                        </TableCell>
                        <TableCell
                          sx={{ ...tableStyles.headerCell, width: "100px" }}
                        >
                          <TableSortLabel
                            active={orderBy === "status"}
                            direction={orderBy === "status" ? order : "asc"}
                            onClick={() => handleRequestSort("status")}
                          >
                            Status
                          </TableSortLabel>
                        </TableCell>
                        {/* <TableCell
                      sx={{ ...tableStyles.headerCell, width: "100px" }}
                    >
                      <TableSortLabel
                        active={orderBy === "priority"}
                        direction={orderBy === "priority" ? order : "asc"}
                        onClick={() => handleRequestSort("priority")}
                      >
                        Priority
                      </TableSortLabel>
                    </TableCell> */}
                        {/* <TableCell sx={{...tableStyles.headerCell, width: "100px"}}>
              <TableSortLabel
                active={orderBy === "colour"}
                direction={orderBy === "colour" ? order : "asc"}
                onClick={() => handleRequestSort("colour")}
              >
                Colour
              </TableSortLabel>
            </TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortedTasks
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((task, index) => (
                          <TableRow key={task._id} sx={{ ...tableStyles.row }}>
                            <TableCell
                              sx={{
                                ...tableStyles.cell,
                                width: "1rem!important",
                              }}
                            >
                              {page * rowsPerPage + index + 1}
                            </TableCell>

                            <TableCell
                              sx={{ ...tableStyles.cell }}
                              // onClick={() => { navigate(`/relationships/${task?.owner?._id}`); }}
                            >
                              {task.owner ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Avatar
                                    alt={task.owner.firstName}
                                    src={
                                      task.owner.avatar ? task.owner.avatar : ""
                                    }
                                    sx={{
                                      fontFamily:
                                        '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                                      fontSize: "7.8px",
                                      height: "1rem",
                                      width: "1rem",
                                      marginRight: "-2px",

                                      color: "#fff",
                                    }}
                                  >
                                    {!task.owner.avatar &&
                                      `${task.owner.firstName.charAt(0)}${
                                        task.owner.middleName
                                          ? task.owner.middleName.charAt(0)
                                          : task.owner.lastName.charAt(0)
                                      }`}
                                  </Avatar>
                                  {`${task.owner.firstName} ${
                                    task.owner.middleName
                                      ? task.owner.middleName + " "
                                      : ""
                                  }${task.owner.lastName}`}
                                </Box>
                              ) : (
                                "N/A"
                              )}
                            </TableCell>

                            <TableCell
                              sx={{
                                ...tableStyles.cell,
                                "&:hover": {
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                },
                                color: "#005b92",
                              }}
                              onClick={() => navigate(`/task/${task._id}`)}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <FormatListNumberedIcon
                                  sx={{ fontSize: 16, color: "gray" }}
                                />
                                <span>{truncateText(task.type, 40)}</span>
                              </Box>
                            </TableCell>

                            <TableCell
                              sx={{
                                ...tableStyles.cell,
                                cursor: "pointer",
                              }}
                            >
                              {task.case?.parties?.find(
                                (p) => p.type === "Client"
                              ) ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Avatar
                                    alt={
                                      task.case.parties.find(
                                        (party) => party.type === "Client"
                                      )?.name?.businessName || "N/A"
                                    }
                                    src={
                                      task.case.parties.find(
                                        (party) => party.type === "Client"
                                      )?.name?.avatar ||
                                      "/static/images/avatar/1.jpg"
                                    }
                                    sx={{
                                      fontFamily:
                                        '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                                      fontSize: "7.8px",
                                      height: "1rem",
                                      width: "1rem",
                                      marginRight: "-2px",
                                    }}
                                  />
                                  <Box
                                    sx={{
                                      lineHeight: "14px",
                                    }}
                                  >
                                    {(() => {
                                      const client = task.case.parties.find(
                                        (party) => party.type === "Client"
                                      )?.name;
                                      return client
                                        ? client.businessName ||
                                            `${client.firstName || ""} ${
                                              client.lastName || ""
                                            }`.trim()
                                        : "N/A";
                                    })()}
                                  </Box>
                                </Box>
                              ) : (
                                "--"
                              )}
                            </TableCell>

                            {/* {console.log("checking", task)} */}
                            <TableCell
                              sx={{
                                ...tableStyles.cell,
                                "&:hover": {
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                },
                                color: "#005b92",
                              }}
                              onClick={() =>
                                navigate(`/files/${task.case._id}/overview`)
                              }
                            >
                              {task.case ? (
                                <>
                                  <Stack direction="row">
                                    <Typography
                                      variant="body2"
                                      // color="textSecondary"
                                      sx={{ fontSize: "0.7rem" }}
                                    >
                                      {task.case.fileNo}
                                    </Typography>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontWeight: "bold",
                                        fontSize: "0.8rem",
                                        marginTop: "-3.5px",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      {truncateText(task.case.name, 25)}
                                    </Typography>
                                  </Stack>
                                </>
                              ) : (
                                "N/A"
                              )}
                            </TableCell>
                            <TableCell sx={tableStyles.cell}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    height: "10px",
                                    width: "10px",
                                    backgroundColor: getColor(task?.colour),
                                  }}
                                />
                                <span>{truncateText(task.subject, 40)}</span>
                              </Box>
                            </TableCell>

                            <TableCell sx={tableStyles.cell}>
                              {new Date(task.dueDate).toLocaleDateString()}
                            </TableCell>
                            <TableCell sx={{ ...tableStyles.cell }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    padding: "1px 6px",
                                    borderRadius: "20px",
                                    backgroundColor: getStatusColor(
                                      task.status
                                    ), // Dynamic color based on status
                                    color:
                                      task.status === "Completed"
                                        ? "black"
                                        : "white", // White text inside the badge
                                    fontSize: "8.25px",
                                    fontFamily:
                                      '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                                    fontWeight: "700",
                                    textTransform: "upperCase",
                                    height: "12px",
                                    letterSpacing: "0.2em",
                                  }}
                                >
                                  {task.status}
                                </Box>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                )}
                <TablePagination
                  component="div"
                  count={filteredTask.length}
                  page={page}
                  onPageChange={handlePageChange}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleRowsPerPageChange}
                />
              </TableContainer>
            </Box>
          </Container>
        </>
      )}

      {tabValue === 5 && (
        <>
          <Box sx={{ backgroundColor: "white", padding: "32px 24px " }}>
            <TableContainer>
              {filteredAppointments.length > 0 ? (
                <Table
                  sx={{ ...tableStyles.container, border: "1px solid #d1d1d1" }}
                  size="small"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell sx={tableStyles.headerCell}>Event</TableCell>
                      <TableCell sx={tableStyles.headerCell}>
                        Start Date
                      </TableCell>
                      <TableCell sx={tableStyles.headerCell}>
                        Start Time
                      </TableCell>
                      <TableCell sx={tableStyles.headerCell}>
                        End Date
                      </TableCell>
                      <TableCell sx={tableStyles.headerCell}>
                        End Time
                      </TableCell>
                      <TableCell sx={tableStyles.headerCell}>Type</TableCell>
                      <TableCell sx={tableStyles.headerCell}>Owner</TableCell>
                      <TableCell sx={tableStyles.headerCell}>Subject</TableCell>
                      <TableCell sx={tableStyles.headerCell}>
                        Location
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {combinedEvents
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((event) => (
                        <TableRow
                          key={event._id}
                          sx={{ ...tableStyles.row, cursor: "pointer" }}
                        >
                          <TableCell sx={tableStyles.cell}>
                            {event.calendarType === "Appointment"
                              ? "Appointment"
                              : "Hearing"}
                          </TableCell>
                          <TableCell sx={tableStyles.cell}>
                            {new Date(event.startDate).toLocaleDateString()}
                          </TableCell>
                          <TableCell sx={tableStyles.cell}>
                            {new Date(event.startDate).toLocaleTimeString()}
                          </TableCell>
                          <TableCell sx={tableStyles.cell}>
                            {new Date(event.endDate).toLocaleDateString()}
                          </TableCell>
                          <TableCell sx={tableStyles.cell}>
                            {new Date(event.endDate).toLocaleTimeString()}
                          </TableCell>
                          <TableCell sx={tableStyles.cell}>
                            <Box display="flex" alignItems="center" gap={1}>
                              {event.calendarType === "Appointment" && (
                                <CalendarTodayOutlinedIcon
                                  sx={{ fontSize: 13 }}
                                />
                              )}
                              {event.calendarType === "Hearing" && (
                                <GavelIcon sx={{ fontSize: 13 }} />
                              )}
                              {event.type}
                            </Box>
                          </TableCell>
                          <TableCell
                            sx={{
                              ...tableStyles.cell,
                              cursor: "pointer", // Make the cell clickable
                            }}
                            onClick={() => {
                              // Navigate to the owner's profile
                              if (event.owner?._id) {
                                navigate(`/relationships/${event.owner._id}`);
                              }
                            }}
                          >
                            {event.owner ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                {/* Avatar */}
                                <Avatar
                                  alt={event.owner.firstName}
                                  src={
                                    event.owner.avatar
                                      ? event.owner.avatar
                                      : "/static/images/avatar/1.jpg"
                                  } // Fallback avatar
                                  sx={{
                                    width: "16px", // Avatar size
                                    height: "16px", // Avatar size
                                    fontSize: "7.8px", // Font size for initials
                                    fontFamily:
                                      '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                                    color: "#fff", // Text color for initials
                                  }}
                                >
                                  {!event.owner.avatar && (
                                    <>
                                      {event.owner.firstName.charAt(0)}
                                      {event.owner.lastName.charAt(0)}
                                    </>
                                  )}
                                </Avatar>

                                {/* Name */}
                                <Box
                                  sx={{
                                    display: "block",
                                    fontFamily:
                                      '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                                    fontSize: "10.5px", // Font size for the name
                                    fontWeight: 400,
                                    lineHeight: "13.5px",
                                    color: "#005b92", // Text color
                                  }}
                                >
                                  {`${event.owner.firstName} ${
                                    event.owner.middleName
                                      ? event.owner.middleName + " "
                                      : ""
                                  }${event.owner.lastName}`}
                                </Box>
                              </Box>
                            ) : (
                              "N/A" // Fallback if no owner is found
                            )}
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              navigate(
                                event.calendarType === "Appointment"
                                  ? `/appointment/${event._id}`
                                  : `/hearing/${event._id}`
                              )
                            }
                            sx={{
                              ...tableStyles.cell,
                              cursor: "pointer",
                              "&:hover": {
                                textDecoration: "underline !important",
                                cursor: "pointer",
                              },
                              color: "#005b92",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  height: "10px",
                                  width: "10px",
                                  backgroundColor: getColor(event?.colour),
                                }}
                              />
                              <span>{event.subject}</span>
                            </Box>
                          </TableCell>
                          <TableCell sx={tableStyles.cell}>
                            {event.location}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              ) : (
                <Box
                  sx={{
                    ...smallTitle,
                    padding: "32px 24px",
                    textAlign: "center",
                  }}
                >
                  No data available
                </Box>
              )}
            </TableContainer>
            <TablePagination
              component="div"
              count={combinedEvents.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
        </>
      )}
    </Container>
  );
};

export default SearchResultsPage;
